import { render, staticRenderFns } from "./PoDetails.vue?vue&type=template&id=5ad97564&scoped=true&"
import script from "./PoDetails.vue?vue&type=script&lang=js&"
export * from "./PoDetails.vue?vue&type=script&lang=js&"
import style0 from "./PoDetails.vue?vue&type=style&index=0&id=5ad97564&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad97564",
  null
  
)

export default component.exports